import formatClubName from '../../utils/formatClubName'
import useAuth from '../../hooks/useAuth'

const ClubOverview = ({ club }) => {
  const { role } = useAuth()

  const { address, clubName, clubId, staff, membershipSpaces } = club
  const { secretary, headCoach, welfareOfficer, dbsVerifier } = staff

  return (
    <div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Club Name</b>
        <div className="w-100 fw-bold">
          {formatClubName(clubName)}
        </div>
      </div>
      <div className="d-flex flex-column flex-sm-row  border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 my-1">Address</b>
        <div className="w-100 fw-bold">
          <p className="m-0">{address.streetAddress}</p>
          <p className="m-0">{address.city}</p>
          <p className="m-0">{address.county}</p>
          <p className="m-0">{address.postcode}</p>
          <p className="m-0">{address.country}</p>
        </div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Club Number</b>
        <div className="w-100 fw-bold">{clubId}</div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Secretary</b>
        <div className="w-100 fw-bold">{secretary.name}</div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Secretary Email</b>
        <div className="w-100 fw-bold">{secretary.email}</div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Head Coach</b>
        <div className="w-100 fw-bold">{headCoach.name}</div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Welfare Officer</b>
        <div className="w-100 fw-bold">{welfareOfficer.name}</div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">Welfare Officer Email</b>
        <div className="w-100 fw-bold">{welfareOfficer.email}</div>
      </div>
      <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
        <b className="text-muted w-100 mb-1">DBS Verifier</b>
        <div className="w-100 fw-bold">{dbsVerifier.name}</div>
      </div>
      {['admin', 'secretary'].includes(role) && (
        <div className="d-flex flex-column flex-sm-row align-items-center border-bottom p-2 custom-hover-tr">
          <b className="text-muted w-100 mb-1">Member Spaces (yearly)</b>
          <div className="w-100 fw-bold">
            {membershipSpaces}
          </div>
        </div>
      )}
    </div>
  )
}

export default ClubOverview